var pdpModulaCollectionCarousel = document.querySelectorAll('.js-pdp-modular-collection-grid');
var media = window.matchMedia('(min-width: 1025px)');
var media2 = window.matchMedia('(max-width: 1200px)');


function initSliders() {
  pdpModulaCollectionCarousel.forEach(function (el, index) {
    console.log(el)
    if (el.dataset.columnsCount > 4) {
      el.classList.add(`s${index}`);
      el.swiper = new Swiper(el, {
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
        },
        slidesPerView: 'auto',
        spaceBetween: 16,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
          type: "progressbar",
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: {
            spaceBetween: 24
          }

        },
      });
    }
    else if (window.matchMedia('(max-width: 1200px)').matches && el.dataset.columnsCount == 4) {
      el.classList.add(`s${index}`);
      el.swiper = new Swiper(el, {
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
        },
        slidesPerView: 'auto',
        spaceBetween: 16,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
          type: "progressbar",
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: {
            spaceBetween: 24
          }

        },
      });
    }
    else if (!media.matches) {
      if (!el.swiper) {
        el.classList.add(`s${index}`);
        el.swiper = new Swiper(el, {
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
          slidesPerView: 'auto',
          spaceBetween: 16,
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
            type: "progressbar",
          },
          navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            768: {
              spaceBetween: 24
            }

          },
        });
      }
    }
  });
}

function destroySliders() {
  pdpModulaCollectionCarousel.forEach(el => {
    if (el.swiper) {
      el.swiper.destroy(true, true);
      el.swiper = null;
    }
  });
}

function handleMediaChange(e) {
  pdpModulaCollectionCarousel.forEach(function (el, index) {
    if (el.dataset.columnsCount > 4) {
      initSliders();
    }
    else if (window.matchMedia('(max-width: 1200px)').matches && el.dataset.columnsCount == 4) {
      initSliders();
    }
    else if (!media.matches) {
      initSliders();
    }
    else {
      destroySliders();
    }
  })
}

initSliders();

media.addEventListener("change", handleMediaChange);
media2.addEventListener("change", handleMediaChange);